module.exports = __webpack_public_path__ + "staticcomp/img/share.685e880.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/1/share.jpg
// module id = Do1Y
// module chunks = 39